import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import './briefing.css';
import App from './app.jsx';

createRoot(document.getElementById('root')).render(<App />);
